import { ReactNode } from 'react';
import { ClearInNavbar } from '../../Navbar/ClearNavbar';
import { b2cData } from '../../cms/layout/components/header';
import { TOPICS, pageCategoryName } from '../../cms/layout/constants';
import { LeftArticleContainer } from '../../cms/layout/styles';
import { getArticles } from '../../cms/layout/util';
import { AuthorSideBio } from '../AuthorSideBio';
import { IAUTHOR } from '../types';

interface IAUTHOR_LAYOUT_PROPS {
  children: ReactNode | JSX.Element;
  showAuthorDetail?: boolean;
  authorData?: IAUTHOR;
}
export const AuthorLayout = ({
  children,
  showAuthorDetail = false,
  authorData,
}: IAUTHOR_LAYOUT_PROPS): JSX.Element => {
  return (
    <div>
      <ClearInNavbar data={b2cData} />

      <div className={`flex sm:flex-col `}>
        <div className="w-1/5 sm:hidden">
          {showAuthorDetail && authorData ? (
            <AuthorSideBio
              name={authorData.name}
              designation={authorData.designation}
              authorImg={authorData.image_url}
              description={authorData.description}
              linkedin={authorData.linkedin_url}
              facebook={authorData.facebook_url}
              twitter={authorData.twitter_url}
              slug={authorData.slug}
            />
          ) : (
            <LeftArticleContainer>
              <div className="mt-12 px-4 pr-8">
                {getArticles(
                  TOPICS['cleartax.in']?.[pageCategoryName.default] || [],
                  'BROWSE BY TOPICS'
                )}
              </div>
            </LeftArticleContainer>
          )}
        </div>
        <div className="w-3/5 sm:w-full sm:px-4">{children}</div>
      </div>
    </div>
  );
};
